import FractionDsn from '@/generated/classes/FractionDsn';
export default class FractionDsnExtend extends FractionDsn {
  constructor() {
    super();
  }
}
